import { useContext } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import { ReactComponent as StandardIcon } from '../../assets/icons/Standard.svg';
import { ReactComponent as ReportingPeriodGroupIcon } from '../../assets/icons/Date Year.svg';
import { ReactComponent as MetricIcon } from '../../assets/icons/Metrics.svg';
import PanelStandards from '../../components/configuration/standards/PanelStandards';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationStandards = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  if (!group || !company) return null;

  // Track module duration.
  useModuleDurationTracking('Configuration', 'Standards', group.id, company.id);

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  const dark_teal: string = theme.palette.teal.dark;

  return (
    <Box>
      <ConfigurationWrapper
        title="Standards"
        icon={<StandardIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={{
          route: '/configuration/reporting-period-groups',
          label: 'Reporting Period Groups',
          icon: <ReportingPeriodGroupIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
        next={{
          route: '/configuration/metrics',
          label: 'Metrics',
          icon: <MetricIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
      >
        <PanelStandards />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationStandards;
